import React, { useState, useEffect } from "react";
import { Breadcrumb, Button, Select, Image, Table, Input, Modal } from "antd";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import Loader from "../../components/loader/loader";
import moment from "moment/moment";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { GreenNotify, RedNotify } from "../../helper/helper";
import UpdateBusiness from "../../components/updateBusiness/updateBusiness";
import Business from "../../components/addBusiness/addBusiness";

import {
  crossIcon,
  homeIcon,
  editIcon,
  redTrash,
  trueIcon,
} from "../../assets";

const Organizers = () => {
  const [business, setBusiness] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedOrganizer, setSelectedOrganizer] = useState(null);
  const [isUpdateModalVisible, setUpdateModalVisible] = useState(false);
  const [updateRecordData, setUpdateRecordData] = useState(null);
  const [isAddBusinessModelVisible, setIsAddBusinessModelVisible] =
    useState(false);
  const [expandedText, setExpandedText] = useState(null);
  const [expandedModalVisible, setExpandedModalVisible] = useState(false);

  const getAllBusiness = () => {
    let getRes = (res) => {
      console.log("response??????", res);
      setBusiness(res?.data?.business);
    };

    callApi(
      "GET",
      `${routes.GetBusiness}`,
      null,
      setIsLoading,
      getRes,
      (error) => {}
    );
  };

  useEffect(() => {
    getAllBusiness();
  }, []);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Description",
      dataIndex: "description",
      className: "type-name-column-header",
      align: "center",
      render: (description) => (
        <div>
          <p>
            {description.length > 50
              ? `${description.slice(0, 30)}...`
              : description}
          </p>
          {description.length > 50 && (
            <Button type="link" onClick={() => handleShowMore(description)}>
              Show More
            </Button>
          )}
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "type",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Location",
      dataIndex: "location",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Stage",
      dataIndex: "stage",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Root",
      dataIndex: "route",
      className: "type-name-column-header",
      align: "center",
    },
    {
      title: "Image",
      dataIndex: "image",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "id",
      className: "type-name-column-header",
      align: "center",
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleUpdate(record.id)}
            style={{ marginRight: 8 }}
          ></Button>
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          ></Button>
        </div>
      ),
    },
  ];
  const data = business
    ?.map((item, index) => {
      return {
        key: index,
        id: item?._id,
        title: item?.title,
        description: item?.description,
        type: item?.type,
        location: item?.location.address,
        stage: item?.stage?.title,
        route: item?.route?.title,

        image: (
          <div className="product-list-image">
            <Image
              style={{
                width: 100,
                height: 100,
                borderRadius: 50,
                objectFit: "cover",
              }}
              src={item?.image}
              alt="profile-image"
            />
          </div>
        ),
      };
    })
    .filter((item) => {
      const titleMatch = item.title
        ?.toLowerCase()
        .includes(searchText?.toLowerCase());
      return titleMatch;
    });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  const handleShowMore = (text) => {
    setExpandedText(text);
    setExpandedModalVisible(true);
  };

  const handleCloseModal = () => {
    setExpandedText(null);
    setExpandedModalVisible(false);
  };

  const handleDelete = (recordId) => {
    console.log(`Delete record with id: ${recordId}`);
    callApi(
      "DELETE",
      `${routes.deleteBusiness}/${recordId}`,
      null,
      setIsLoading,
      (res) => {
        console.log("this is my response", res);

        if (res.status === 200) {
          setBusiness((prevBusiness) =>
            prevBusiness.filter((business) => business._id !== recordId)
          );

          GreenNotify("Point Of Interest Deleted Successfully");
        } else {
          RedNotify("Error Occurred while deleting Generes");
        }
      },
      (error) => {
        console.log("error", error);

        notification.error({
          message: "Error",
          description: "An error occurred while deleting the Generes.",
        });
      }
    );
  };

  const handleAddBusinessModelClick = () => {
    setIsAddBusinessModelVisible(true);
  };

  const handleUpdate = (recordId) => {
    console.log("Selected id", recordId);
    const selectedBusiness = business.find(
      (business) => business._id === recordId
    );
    console.log("selectedBusiness??????", selectedBusiness);

    setUpdateRecordData(selectedBusiness);
    setUpdateModalVisible(true);
  };

  return (
    <div className="admin-products-main-container">
      <Loader loading={isloading} />
      <Breadcrumb separator=">" className="bread-crumb">
        <div className="configure-server-home-icon">
          <img src={homeIcon} alt="home-icon" />
        </div>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Point Of Interest</Breadcrumb.Item>
      </Breadcrumb>
      <div className="configure-server-roles-main-heading-container">
        <h1>Point Of Interest</h1>
        <div></div>
        <div className="search-inputs" style={{ width: "30rem" }}>
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      {
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddBusinessModelClick}
          style={{ marginBottom: "16px" }}
        >
          Add Business
        </Button>
      }
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        ></Table>
      </div>

      <UpdateBusiness
        visible={isUpdateModalVisible}
        toggleModal={() => {
          setUpdateModalVisible(false);
          getAllBusiness();
        }}
        onCancel={() => setUpdateModalVisible(false)}
        recordData={updateRecordData}
        selectedOrganizer={selectedOrganizer}
      />
      {isAddBusinessModelVisible && (
        <Business
          visible={isAddBusinessModelVisible}
          toggleModal={() => {
            setIsAddBusinessModelVisible(false);
            getAllBusiness();
          }}
        />
      )}

      <Modal
        title="Point Of Interest Description"
        visible={expandedModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        <p style={{ textAlign: "justify" }}>{expandedText}</p>
      </Modal>
    </div>
  );
};

export default Organizers;
